import "./../../styles/NotificationHeader.css";

const NotificationHeader = ({ onCreate }) => {
    return (
        <div className="notification-header">

            <div>
                <h2>Notifications</h2>
                <p>
                    Create, schedule and manage notifications
                    for customers, providers and delivery partners.
                </p>
            </div>

            <button
                className="create-notification-btn"
                onClick={onCreate}
            >
                + Create Notification
            </button>

        </div>
    );
};

export default NotificationHeader;